import {ValidationProvider, extend} from 'vee-validate/dist/vee-validate.full';
import {validate} from "../utils/validate";


export default {
  install(Vue, options: any = {}) {
    Vue.component('ValidationProvider', ValidationProvider);
    extend('numberInput', {
      message(fieldName) {
        return `${fieldName} must be numberic`;
      },
      validate(value) {
        return validate.validateNumberInput(value);
      }
    });
    extend('phoneNumber', {
      message(fieldName) {
        return `${fieldName} is not a valid`;
      },
      validate(value) {
        return validate.validatePhoneNumber(value);
      }
    });
    extend('email', {
      message(fieldName) {
        return `The ${fieldName} field must be a valid email`;
      },
      validate(value) {
        return validate.validateEmail(value);
      }
    });
    extend('ipAddress', {
      message(fieldName) {
        return `The ${fieldName} field must be a valid ip address`;
      },
      validate(value) {
        return validate.validateIPaddress(value);
      }
    });
    extend('validateDnsServer', {
      message(fieldName) {
        return `The ${fieldName} field must be a valid dns server`;
      },
      validate(value) {
        return validate.validateDnsServer(value);
      }
    });
    extend('ipAddressRange', {
      message(fieldName) {
        return `The ${fieldName} field must be a valid ip address`;
      },
      validate(value) {
        return validate.validateIpAddressRange(value);
      }
    });
    extend('domain', {
      message(fieldName) {
        return `The ${fieldName} field must be a valid domain`;
      },
      validate(value) {
        return validate.validateDomain(value);
      }
    });
    extend('domainOrIpAddress', {
      message(fieldName) {
        return `The ${fieldName} field must be a valid domain or ip address.`;
      },
      validate(value) {
        return validate.validateDomain(value) || validate.validateIPaddress(value);
      }
    });
    extend('portNumber', {
      message(fieldName) {
        return `The ${fieldName} field must be a valid port number.`;
      },
      validate(value) {
        return validate.validatePortNumber(value);
      }
    });
    extend('portNumberRange', {
      message(fieldName) {
        return `The ${fieldName} field must be a valid port number.`;
      },
      validate(value) {
        return validate.validatePortNumberRange(value);
      }
    });
    extend('subnets', {
      message(fieldName) {
        return `The ${fieldName} field must be a valid subnet format (exp: 1.2.3.4/16)`;
      },
      validate(value) {
        let valid = false
        for (const valueKey of value) {
          valid = validate.validateSubnet(valueKey);
          if (!valid) {
            return valid
          }
        }
        return true
      }
    });
    extend("custom", async (value, data) => {
      const result = await data[0](value)
      return result
    }, {
      paramNames: ["callback"]
    })
  }
}
